module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "navTabs"
    }
  }, [_c('li', {
    staticClass: "viewTabLi active",
    attrs: {
      "id": "active-jobs-li"
    }
  }, [_c('a', {
    attrs: {
      "href": "#dashboard-tools-tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.tabChanged("tools")
      }
    }
  }, [_vm._v("Dashboards")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "list-tab"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-defualt",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Refresh"
    },
    on: {
      "click": _vm.refreshDashboardList
    }
  }, [_vm._v("\n                            Refresh\n                            "), _c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('table', {
    staticClass: "table export-table table-condensed",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._m(2), _vm._v(" "), _vm._l((_vm.value), function(item, index) {
    return _c('tr', [_c('td', [_vm._v("\n                                        " + _vm._s(item.name) + "\n                                    ")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_vm._v(" " + _vm._s(item.url) + " ")])]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(item.lastChangeStr) + "\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(item.lastChangedByName) + "\n                                    ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "type": "button",
        "disabled": _vm.isBusy
      },
      on: {
        "click": function($event) {
          return _vm.onOpenDashboardClick(item)
        }
      }
    }, [_vm._v("View")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "type": "button",
        "disabled": _vm.isBusy
      },
      on: {
        "click": function($event) {
          return _vm.onEditDashboardClick(item)
        }
      }
    }, [_vm._v("Edit")])])])
  })], 2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dashboards")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "span": "1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Url")]), _vm._v(" "), _c('th', [_vm._v("Last Changed")]), _vm._v(" "), _c('th', [_vm._v("Last Changed By")]), _vm._v(" "), _c('th', [_vm._v("Options")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f3adb34c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3adb34c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/dashboard-list/dashboard-list.vue.html
// module id = 1135
// module chunks = 0